export function detectSizeFromTag(tag: string): string | null {
  if (!tag) return null;

  let width: number | null = null;
  let height: number | null = null;

  // Match width/height attributes
  const attrPattern = /(?:width|WIDTH)\s*=\s*["']?(\d+)["']?|(?:height|HEIGHT)\s*=\s*["']?(\d+)["']?/g;
  const attrMatches = Array.from(tag.matchAll(attrPattern));
  attrMatches.forEach((match) => {
    if (match[1] && !width) width = parseInt(match[1], 10);
    if (match[2] && !height) height = parseInt(match[2], 10);
  });

  // Match width/height without quotes
  const noQuotePattern = /(?:WIDTH|width)\s*=\s*(\d+)|(?:HEIGHT|height)\s*=\s*(\d+)/g;
  const noQuoteMatches = Array.from(tag.matchAll(noQuotePattern));
  noQuoteMatches.forEach((match) => {
    if (match[1] && !width) width = parseInt(match[1], 10);
    if (match[2] && !height) height = parseInt(match[2], 10);
  });

  // Match width/height in style attributes
  const stylePattern = /(?:width|WIDTH)\s*:\s*(\d+)px|(?:height|HEIGHT)\s*:\s*(\d+)px/gi;
  const styleMatches = Array.from(tag.matchAll(stylePattern));
  styleMatches.forEach((match) => {
    if (match[1] && !width) width = parseInt(match[1], 10);
    if (match[2] && !height) height = parseInt(match[2], 10);
  });

  // Match WxH pattern (e.g., 300x250)
  const sizePattern = /(\d+)\s*[xX×]\s*(\d+)/;
  const sizeMatch = tag.match(sizePattern);
  if (sizeMatch) {
    if (!width) width = parseInt(sizeMatch[1], 10);
    if (!height) height = parseInt(sizeMatch[2], 10);
  }

  if (width && height) {
    return `${width}x${height}`;
  }

  return null;
}

export function detectCreativeTypeFromTag(tag: string): 'banner' | 'mraid' | 'video' | 'moments' {
  if (!tag) return 'banner';

  const lowerTag = tag.toLowerCase();

  if (
    lowerTag.includes('vast') ||
    lowerTag.includes('vmap') ||
    lowerTag.includes('video') ||
    lowerTag.includes('.mp4') ||
    lowerTag.includes('.webm') ||
    lowerTag.includes('videojs') ||
    lowerTag.includes('jwplayer')
  ) {
    return 'video';
  }

  if (
    lowerTag.includes('mraid') ||
    lowerTag.includes('mraid.js') ||
    lowerTag.includes('mraid:') ||
    lowerTag.includes('getstate') ||
    lowerTag.includes('expand') ||
    lowerTag.includes('close')
  ) {
    return 'mraid';
  }

  if (
    lowerTag.includes('moments') ||
    lowerTag.includes('inhand') ||
    lowerTag.includes('engagement.inmarket.com')
  ) {
    return 'moments';
  }

  return 'banner';
}

export function getDeviceTypeFromAdSize(size: string | null): 'mobile' | 'tablet' | 'desktop' | 'ctv' | null {
  if (!size) return null;

  const [width, height] = size.split('x').map(Number);
  if (!width || !height) return null;

  if (width === 728 && height === 90) {
    return 'tablet';
  }

  const mobileSizes = [
    { w: 320, h: 50 },
    { w: 320, h: 240 },
    { w: 320, h: 480 },
    { w: 480, h: 320 },
    { w: 300, h: 50 },
  ];

  if (mobileSizes.some((s) => s.w === width && s.h === height)) {
    return 'mobile';
  }

  const tabletDesktopSizes = [
    { w: 728, h: 90 },
    { w: 970, h: 250 },
    { w: 970, h: 90 },
    { w: 468, h: 60 },
  ];

  if (tabletDesktopSizes.some((s) => s.w === width && s.h === height)) {
    if (width >= 970) {
      return 'desktop';
    }
    return 'tablet';
  }

  const desktopSizes = [
    { w: 160, h: 600 },
    { w: 300, h: 600 },
    { w: 336, h: 280 },
  ];

  if (desktopSizes.some((s) => s.w === width && s.h === height)) {
    return 'desktop';
  }

  if (width === 300 && height === 250) {
    return 'mobile';
  }

  if (width > 600) {
    return width >= 970 ? 'desktop' : 'tablet';
  }

  if (height > 500) {
    return 'desktop';
  }

  if (width <= 400) {
    return 'mobile';
  }

  return 'mobile';
}
